// "Apagar histórico" (pedido 2026-09-08, aba Perfil do PWA) — GPS Drive
// Backend, módulo history-deletions. Nunca apaga a posição real no
// Traccar; só marca um período como oculto para a empresa. Ver
// src/lib/history-deletion-filter.ts (aplica o filtro em cima do que o
// Traccar devolve) e components/vehicle-history-delete-dialog.tsx (tela
// que chama create()).
import { gpsDriveGet, gpsDrivePost } from "@/lib/api/gpsdrive-client";

export interface HistoryDeletionEntry {
  id: string;
  traccarDeviceId: number;
  periodFrom: string;
  periodTo: string;
  periodLabel: string;
  deletedByUserId: string;
  deletedByName: string;
  createdAt: string;
  restoredByUserId: string | null;
  restoredByName: string | null;
  restoredAt: string | null;
}

export interface CreateHistoryDeletionInput {
  traccarDeviceId: number;
  periodFrom: string;
  periodTo: string;
  periodLabel: string;
  password: string;
}

export const historyDeletionsService = {
  listForDevice: (traccarDeviceId: number): Promise<HistoryDeletionEntry[]> =>
    gpsDriveGet<HistoryDeletionEntry[]>(`/api/v1/history-deletions?traccarDeviceId=${traccarDeviceId}`),

  create: (input: CreateHistoryDeletionInput): Promise<HistoryDeletionEntry> =>
    gpsDrivePost<HistoryDeletionEntry>("/api/v1/history-deletions", input),

  restore: (id: string): Promise<HistoryDeletionEntry> =>
    gpsDrivePost<HistoryDeletionEntry>(`/api/v1/history-deletions/${id}/restore`),
};
